import { Box, SxProps } from "@mui/material";
import { useEffect, useRef } from "react";
import { JSONEditorPropsOptional, JsonEditor, createJSONEditor } from "vanilla-jsoneditor";



interface Props extends JSONEditorPropsOptional {
    className?: string,
    style?: React.CSSProperties,
    sx?: SxProps
}

export function ReactJsonEditor({ className, style, sx, ...props }: Props) {
    const refContainer = useRef(null);
    const refEditor = useRef<JsonEditor | null>(null);
    const refPrevProps = useRef<JSONEditorPropsOptional>(props);

    useEffect(() => {
        refEditor.current = createJSONEditor({
            target: refContainer.current!,
            props: props
        });

        return () => {
            // destroy editor
            if (refEditor.current) {
                // console.log("destroy editor");
                refEditor.current.destroy();
                refEditor.current = null;
            }
        };
    }, []);

    // update props
    useEffect(() => {
        if (refEditor.current) {

            const changedProps = filterUnchangedProps(props, refPrevProps.current);
            refEditor.current.updateProps(changedProps);
            refPrevProps.current = props;
        }
    }, [props]);

    return <Box className={className} style={style} ref={refContainer} sx={sx} />;
}

function filterUnchangedProps(
    props: JSONEditorPropsOptional,
    prevProps: JSONEditorPropsOptional
): JSONEditorPropsOptional {
    return Object.fromEntries(
        Object.entries(props).filter(
            ([key, value]) =>
                value !== prevProps[key as keyof JSONEditorPropsOptional]
        )
    );
}